import React, { useState } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";
import FlexBreak from "../../../../../FlexBreak";

const GET_PLAYER = graphql`
  query PGAProfileHeaderQuery($playerId: ID!) {
    playerInfo(playerId: $playerId) {
      name

      sport {
        name
      }

      playerDkId
      headshotUrl
    }
  }
`;

export default function PGAProfileHeader({ playerId }) {
  const data = useLazyLoadQuery(GET_PLAYER, { playerId });

  const player = data.playerInfo;

  const headshotUrl = player.headshotUrl;

  return (
    <div className="pga-profile-header-container">
      {headshotUrl ? (
        <img src={headshotUrl} alt={"Headshot for " + player.name} />
      ) : null}
      <br />
      <h1 style={{ textAlign: "center" }}>{player.name}</h1>
    </div>
  );
}
